module.exports = __webpack_public_path__ + "static/img/011.d6ca315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/011.png
// module id = ILvZ
// module chunks = 1